import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import newError, { clientErrors, firstResponseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import { applyDictionaries, hideDictionaryLookups, updateLookupProperties } from '../../dictionaries/actions';
import validateLookupItems, { transformLookups } from '../helper';
import DictionaryLookupContent from './DictionaryLookupContent';
import DictionaryLookupActions from './DictionaryLookupActions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryLookupDialog = ({
  applyChanges,
  dictionaries,
  hide,
  saveErrors,
  template,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => updateProperties({ saveErrors: newErrors });

  const setStatus = (status) => updateProperties({ saveStatus: status });

  const validateForm = () => {
    const validationErrors = [];
    dictionaries.forEach((dictionary) => {
      const validationDictionary = {
        ...dictionary,
        lookups: transformLookups(dictionary.lookups),
      };
      validateLookupItems(validationDictionary, validationErrors, intl);
    });

    if (validationErrors.length > 0) {
      validationErrors.unshift(
        newError(
          intl.formatMessage({ id: 'validation.general.invalid.title' }),
          null,
          intl.formatMessage({ id: 'validation.general.invalid' }),
        ),
      );
    }

    return validationErrors;
  };

  const checkForErrors = () => {
    const validationErrors = validateForm();
    setErrors(validationErrors);

    return validationErrors;
  };

  const handleDismiss = () => {
    setErrors(clientErrors(saveErrors));
  };

  const submitForm = () => {
    setStatus(states.PENDING);
    const validationErrors = checkForErrors();

    if (validationErrors.length > 0) {
      setStatus(states.NONE);
    } else {
      applyChanges(template);
    }
  };

  return (
    <DialogWrapper
      className="aridhia-dictionary-lookup-dialog smallwizard"
      error={firstResponseError(saveErrors)}
      onClose={hide}
      onDismiss={handleDismiss}
      size="large"
      theme={theme}
      title={intl.formatMessage({ id: 'dictionary.lookups.title' })}
    >
      <Modal.Content scrolling>
        <DictionaryLookupContent />
      </Modal.Content>
      <DictionaryLookupActions onClose={hide} onSave={submitForm} />
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets, lookups },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const { template } = resolveCatalogueTemplate(datasets, templates, lookups);
  const items = dictionary ? dictionary.lookups || {} : {};
  const lookupType = items[lookups.activeLookupName] ? items[lookups.activeLookupName].type : 'text';

  return (
    {
      category: lookups.category,
      code: lookups.code,
      dictionaries: lookups.dictionaries,
      lookupType,
      saveErrors: lookups.saveErrors,
      template,
    }
  );
};

const mapDispatchToProps = {
  applyChanges: applyDictionaries,
  hide: hideDictionaryLookups,
  updateProperties: updateLookupProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryLookupDialog);
